namespace st.search {
    class FacetSearchResultsController implements controllers.IFacetSearchResultsController {

        group: string = DefaultGroup;
        results: services.ISearchResponse;
        pages: models.IResultPage[] = [];

        static $inject = ['$rootScope', 'stFacetService'];

        constructor($rootScope: angular.IRootScopeService, private facetService: services.IFacetService) {

            $rootScope.$on('stRegisterFacets', (e: angular.IAngularEvent) => {
                this.facetService.registerFacets(this.group);
            });

            $rootScope.$on('stFacetsInit', (e: angular.IAngularEvent, search, groups: string[]) => {
                const curPage = this.facetService.getPageId(this.group);
                const pageChanged = this.selectPageId(curPage, false);
                if (pageChanged) {
                    groups.push(this.group);
                }
                const sort = this.facetService.getSortBy(this.group).join(SortSeparator);
                if (sort && (<any>this).sortBy !== sort) {
                    (<any>this).sortBy = sort;
                    groups.push(this.group);
                }
            });

            $rootScope.$on('stSearchResponse', (
                e: angular.IAngularEvent,
                response: services.ISearchResponse | services.ISearchResponse[],
                group: string
            ) => {
                if (!angular.isUndefined(group) && group === this.group) {
                    if (Array.isArray(response)) {
                        if (response.length) {
                            this.results = response[response.length - 1];
                        }
                    } else {
                        this.results = response;
                    }
                    if (this.results) {
                        this.pages.length = this.results.Pages;
                        for (let i = 0; i < this.results.Pages; i++) {
                            if (this.pages[i]) {
                                this.pages[i].isActive = i === this.results.Page - 1;
                            } else {
                                this.pages[i] = {
                                    id: i + 1,
                                    isActive: i === this.results.Page - 1
                                };
                            }
                        }
                    } else {
                        this.pages.length = 0;
                    }
                }
            });
        }

        get isSearching(): boolean {
            return this.facetService.isSearching[this.group];
        }

        selectPage(page: models.IResultPage, notify = true): boolean {
            return this.selectPageId(page.id, notify);
        }

        selectPageIndex(index: number, notify = true): boolean {
            let page: models.IResultPage;
            if (0 <= index && index < this.pages.length && (page = this.pages[index])) {
                return this.selectPageId(page.id, notify);
            }
            return false;
        }

        selectPageId(id: number, notify = true): boolean {
            let pageChanged = false;
            this.pages.forEach(page => {
                if (page.id === id) {
                    if (!page.isActive) {
                        page.isActive = true;
                        pageChanged = true;
                    }
                } else {
                    if (page.isActive) {
                        page.isActive = false;
                        pageChanged = true;
                    }
                }
            });
            if (pageChanged && notify) {
                this.facetService.setPage(id, this.group);
            }
            return pageChanged;
        }

        nextPage(): boolean {
            let idChanged = 0;
            for (let i = 0; i < this.pages.length; i++) {
                const page = this.pages[i];
                if (page.isActive) {
                    if (i + 1 < this.pages.length) {
                        page.isActive = false;
                        this.pages[i + 1].isActive = true;
                        idChanged = this.pages[i + 1].id;
                    }
                    break;
                }
            }
            if (idChanged > 0) {
                this.facetService.setPage(idChanged, this.group);
                return true;
            }
            return false;
        }

        prevPage(): boolean {
            let idChanged = 0;
            for (let i = 0; i < this.pages.length; i++) {
                const page = this.pages[i];
                if (page.isActive) {
                    if (i > 0) {
                        page.isActive = false;
                        this.pages[i - 1].isActive = true;
                        idChanged = this.pages[i - 1].id;
                    }
                    break;
                }
            }
            if (idChanged > 0) {
                this.facetService.setPage(idChanged, this.group);
                return true;
            }
            return false;
        }

        // This is really for demo purposes of sorting
        sortChanged(): void {
            const x: any[] = ((<any>this).sortBy || '').split(SortSeparator);
            x.unshift(this.group);
            this.facetService.setSortBy.apply(this.facetService, x);
        }
    }

    angular.module('st.search')
        .controller('stFacetSearchResultsCtrl', FacetSearchResultsController);
}
